import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router";
import { ssoApi } from "../../api/sso";
import FullScreenLoader from "../../components/fullScreenLoader/FullScreenLoader";
import { getSharedVariables } from "../../variables";
import { RedirectKeys } from "../authTypes";
import { getAuthSettings } from "../settings";

type SignUpStatus = "not_signed_up" | "signed_up" | "sign_up_failed";

const SignUp = () => {
  const [searchParams] = useSearchParams();

  const authCode = searchParams.get(RedirectKeys.Code);

  const [signUpState, setSignUpState] = useState<SignUpStatus>("not_signed_up");

  useEffect(() => {
    if (authCode) {
      const acquireSignupToken = async () => {
        try {
          const { clientId, userFlowSignUp, cookieTarget } = getAuthSettings();
          const redirectUri = getSharedVariables().PORTAL_REDIRECT_URI;

          const response = await ssoApi.requestToken({
            clientId,
            redirectUri,
            authCode,
            userFlow: userFlowSignUp,
            cookieTarget,
          });

          if (response) {
            setSignUpState("signed_up");
          }
        } catch {
          setSignUpState("sign_up_failed");
        }
      };

      acquireSignupToken();
    }
  }, [authCode]);

  if (!authCode) {
    return <Navigate to="/" />;
  }

  switch (signUpState) {
    case "not_signed_up": {
      return <FullScreenLoader title="Please wait." subtitle="Signing up..." />;
    }
    case "signed_up": {
      return <Navigate to={{ pathname: "/", search: "" }} replace />;
    }
    case "sign_up_failed": {
      return <Navigate to={{ pathname: "/error", search: "" }} />;
    }
    default: {
      return null;
    }
  }
};

export default SignUp;
